import { DefaultMap, hexToRgba } from 'helpers';
import $ from 'jquery';


export const initStyle = (theme) => {
  let styleKw = new DefaultMap(() => []);

  Object.entries(theme).forEach(([k, v]) => {
    if (!v) { return; }

    if (k === 'background') {
      let color = hexToRgba(v);
      if (theme.hasOwnProperty('background_opacity')) {
        color += `, ${theme.background_opacity/10}`;
      }
      styleKw.get('#welcome_wrapper').push(`background: rgba(${color})`);
      return;
    }
    if (k === 'color') {
      styleKw.get('label.active').push(`color: ${v} !important`);
      return;
    }
    if (k === 'buttonbackground') {
      styleKw.get('.connect').push(`background-color: ${v}`);
      return;
    }
    if (k === 'buttoncolor') {
      styleKw.get('.connect').push(`color: ${v}`);
      return;
    }
    if (k === 'titlecolor') {
      styleKw.get('#title').push(`color: ${v}`);
      return;
    }
    if (k === 'border') {
      styleKw.get('input:focus').push(`border-bottom: 1px solid ${v} !important`);
      styleKw.get('input:focus').push(`box-shadow: 0 1px 0 0 ${v} !important`);
      return;
    }
    if (k === 'font') {
      styleKw.get('body').push(`font-family: ${v}`);
      return;
    }
    if (k === 'page_bg') {
      styleKw.get('.full-page-intro').push(`background-color: ${v}`);
      return;
    }
    if (k === 'page_bg_img') {
      styleKw.get('.full-page-intro').push(`background-image: url('/static/images/form_backgrounds/${v}')`);
      return;
    }
  });
  let style_css = '';
  for (let [k, v] of styleKw.entries()) {
    style_css += `${k} { ${v.join(';')} } `;
  }
  $('head').append(`<style>${style_css} </style>`);
}

export const initText = (pub, project) => {
  if (project.logo) {
    $('.logo').attr({
      src: `data:image/gif;base64,${project.logo}`,
      alt: project.alt_logo,
    });
  }
  document.title = pub.display_name;
  document.documentElement.lang = pub.locales.localization;
  $('#title').append(pub.welcome.title);
  $('#description').append(pub.welcome.description);
  $('#label_submit').text(pub.locales.connect);

  if (pub.locales.direction === 'rtl') {
    $('html').addClass('rtl');
  }
  if (pub.locales.localization === 'he') {
    $('#connect_disclaimer').text('עם הלחיצה על "התחבר" תקבל\\י למספר הטלפון והמייל לינק שאיתו תוכל\\י להמשיך למלא את הטופס');
    $('#link_avail').text(` הלינק יהיה זמין ל-${pub.ttl || '24'}שעות `);
  } else {
    $('#connect_disclaimer').text('With click on "Connect", you will receive a link which allow you to proceed with completing the form');
    $('#link_avail').text(`Link will be available for the next: ${pub.ttl || '24'} hours`);
  }
}
